import moment from 'moment';

export const formatDate = (value: string): string => {
    return moment(value).format("DD/MM/YYYY")
}

export const timeStampToDate = (timestamp: string): string => {
    return moment(timestamp).format("MMMM Do YYYY")
}

export const datesHoursDiff = (date1: string, date2: string): number => {
    let diff = (new Date(date2).getTime() - new Date(date1).getTime()) / 1000;
    diff /= (60 * 60);
    return Math.abs(Math.round(diff));
}